import { render, staticRenderFns } from "./SliderLayout.vue?vue&type=template&id=61fe6057"
import script from "./SliderLayout.vue?vue&type=script&lang=js"
export * from "./SliderLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports